import COMMON_CONSTANTS from '../common/constants.js.erb';
import { consentAllows } from './consent';

function generateEventId() {
  if (typeof window === 'undefined') { return null; }
  const { crypto } = window;

  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }

  if (crypto?.getRandomValues) {
    const buffer = new Uint32Array(4);
    crypto.getRandomValues(buffer);
    return Array.from(buffer, (value) => value.toString(16).padStart(8, '0')).join('');
  }

  return `fb_evt_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

function trackAddToBag(productId, price, eventId) {
  if (!window.fbq || !consentAllows('advertising')) { return; }
  const payload = {
    content_ids: productId,
    content_type: 'product',
    product_catalog_id: COMMON_CONSTANTS.FACEBOOK_PRODUCT_CATALOG_ID,
    value: price,
    currency: 'USD',
  };

  window.fbq('track', 'AddToCart', payload, { eventID: String(eventId) });
}

function multiPurposeTrack(event, eventId) {
  if (!window.fbq || !consentAllows('advertising')) { return; }

  if (eventId) {
    window.fbq('track', event, {}, { eventID: String(eventId) });
    return;
  }

  window.fbq('track', event);
}

const facebookPixel = {
  trackAddToBag,
  multiPurposeTrack,
  generateEventId,
};

export default facebookPixel;
